import {type FC, useMemo} from 'react';

import type {Channel} from '../../../../types';

import {getFileSrc} from '../../../../../../utils/entity/file';
import {DMChannelsListItemJSX} from '../../../../components/ChannelsListItem/DMChannelsListItem';
import {ChannelInfoStore} from '../../../../stores/ChannelInfo';

type Props = {
  channel: Channel;
};

export const DMChannelsListItem: FC<Props> = ({channel}) => {
  const store = useMemo(
    () => new ChannelInfoStore({channel, channelId: channel._id}),
    [channel],
  );

  return (
    <DMChannelsListItemJSX
      avatarUrl={getFileSrc(store.avatar, 250).url ?? undefined}
      title={store.title}
    />
  );
};
